export default __webpack_public_path__ + "static/media/chat.304c50bf.svg";